import { useEffect } from "react";
import Navbar from "@/components/navbar";
import Footer from "@/components/footer";
import { Card, CardContent } from "@/components/ui/card";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";
import { updateSEOTags, seoConfigs } from "@/utils/seo";

export default function FAQ() {
  // SEO Optimization
  useEffect(() => {
    updateSEOTags(seoConfigs.faq);
  }, []);

  const faqs = [
    {
      question: "Who can participate in PrizeDrop competitions?",
      answer: "You must be a legal resident of South Africa or other eligible Sub-Saharan African countries where PrizeDrop operates, be 18 years or older, and provide valid proof of identity when required. Competition is free to enter with no purchase necessary."
    },
    {
      question: "How do I enter a competition?",
      answer: "Register on PrizeDrop and create your profile. Enter by completing in-app actions like filling out profile information, participating in quizzes, referring friends, or other gamified tasks. All entries are free and you only need internet connectivity to participate."
    },
    {
      question: "How are winners selected and notified?",
      answer: "Winners are selected by random draw from all eligible entries, conducted fairly with independent oversight. Daily prize winners are notified within 48 hours, and campaign winners within 7 days via email, in-app notifications, or SMS using your profile contact details."
    },
    {
      question: "How long do I have to claim my prize if I win?",
      answer: "For daily prizes, you must confirm and provide required proof of identity within FIVE (5) HOURS of the official winner announcement. Failure to respond within this timeframe results in immediate forfeiture, and a redraw may be conducted."
    },
    {
      question: "What information do I need to provide to claim a prize?",
      answer: "Winners must provide verification of identity and age (copy of valid ID document), confirm eligibility compliance, complete any required tax forms, and agree to publicity terms where your first name and surname initial may be published."
    },
    {
      question: "How do bonus entries work?",
      answer: "You can earn additional entries through gamified actions like completing daily challenges, engaging with content, referring friends, or optionally sharing on social media. Social sharing is completely voluntary and not required to enter competitions."
    },
    {
      question: "What types of prizes are available?",
      answer: "Prizes include mobile airtime vouchers, digital vouchers with partner companies, bursaries or education scholarships, and other merchandise or services. Total prize value per competition campaign will not exceed R100,000 to comply with South African Consumer Protection Act regulations."
    },
    {
      question: "Are prizes transferable or exchangeable for cash?",
      answer: "No, prizes are not transferable or exchangeable for cash unless specifically allowed in writing by the Promoter. All prizes are awarded 'as is' and the Promoter may substitute prizes with items of equal or greater value if needed."
    },
    {
      question: "Who cannot participate in competitions?",
      answer: "Directors, employees, consultants of PrizeDrop and affiliated companies, anyone involved in organizing competitions, their immediate family members, and suppliers of goods/services connected to competitions are not eligible to participate."
    },
    {
      question: "Can I have multiple accounts or enter the same competition multiple times?",
      answer: "No, each participant is limited to one account and one entry per competition round unless competition rules specify otherwise. Multiple accounts or fraudulent entries are prohibited and lead to disqualification."
    },
    {
      question: "How does PrizeDrop comply with South African law?",
      answer: "PrizeDrop operates as a promotional competition under Section 36 of the Consumer Protection Act, 2008. Terms are filed with the National Consumer Commission when required, and records are retained for at least 3 years as legally required."
    },
    {
      question: "What are my tax obligations if I win?",
      answer: "Winners are responsible for any applicable taxes or duties related to prize acceptance. Under current South African law, promotional competition prizes are generally not subject to income tax, but any applicable taxes are the winner's responsibility."
    },
    {
      question: "How do I update my profile information?",
      answer: "Update your profile through your dashboard to ensure accurate contact information. Providing complete profile information may award additional entries, but this is voluntary - you can still enter competitions with basic information."
    },
    {
      question: "Is my personal data secure?",
      answer: "Yes, we follow strict data protection practices. All personal information must be truthful and accurate. We maintain privacy controls and comply with applicable data protection regulations for South African and Sub-Saharan African users."
    },
    {
      question: "What happens if a competition needs to be cancelled?",
      answer: "The Promoter reserves the right to modify or cancel competitions due to circumstances beyond reasonable control. In such cases, participants will be notified and alternative arrangements may be made where possible."
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      {/* Header */}
      <section className="primary-gradient text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <HelpCircle className="h-16 w-16 mx-auto mb-4" />
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Frequently Asked Questions
            </h1>
            <p className="text-xl text-indigo-100">
              Find answers to common questions about our competition platform
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card>
            <CardContent className="p-8">
              <Accordion type="single" collapsible className="w-full">
                {faqs.map((faq, index) => (
                  <AccordionItem key={index} value={`item-${index}`}>
                    <AccordionTrigger className="text-left">
                      {faq.question}
                    </AccordionTrigger>
                    <AccordionContent>
                      {faq.answer}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </CardContent>
          </Card>


        </div>
      </section>

      <Footer />
    </div>
  );
}
